import { QueryKeys } from '../../../queryDefaults/QueryKeys';

import { HealthcareFacilitiesApi } from '../../../apis/HealthcareFacilitiesApi/HealthcareFacilitiesApi.ts';
import { HealthcareFacility } from '../HealthcareFacility.ts';
import { useLowFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useLowFrequencyRefreshQuery.tsx';

export function useGetHealthcareFacilityNew() {
    return useLowFrequencyRefreshQuery({
        queryKey: [QueryKeys.healthcareFacilityNew],
        queryFn: async () => {
            const result = await HealthcareFacilitiesApi.getHealthcareFacilityNew();
            return result ? new HealthcareFacility(result) : result;
        },
    });
}
